import React, { useEffect, useState } from "react";
import "./KontaktPravnogLica.scss";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import "../components/InputPoruka.scss";
import "../components/FormValidationsWarning.scss";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function PrihvatanjePonudeFizickogLica() {
  const { baseUrl, token } = config;
  const cookies = new Cookies();
  const user = cookies.get("fizickoLice");
  const params = useParams();
  const [ponuda, setPonuda] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      const response = await axios.get(
        `${baseUrl}/fizicko/pristigle-ponude/${user.korisnickoIme}`,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      setPonuda(response.data[params.id] || {});
    }

    getData();
  }, [baseUrl, token, params.id, user.korisnickoIme]);

  async function finishOffer(accepted) {
    await axios.post(
      `${baseUrl}/fizicko/zavrsi-ponudu`,
      {
        korisnickoIme: user.korisnickoIme,
        pravnoLice: ponuda.imePravnogLica,
        accepted,
        offer: params.id,
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
        },
      }
    );

    navigate("/");
  }

  return (
    <div id="kontakt-pravnog-lica">
      <Head title="Prihvatanje ponude fizičkog lica" />
      <HeaderComponent />
      <h2>Novi zahtjevi za uslugama</h2>
      <ul>
        <li>{ponuda.date}</li>
        <li>{ponuda.imePravnogLica}</li>
        <li>{ponuda.telefon}</li>
      </ul>

      <label>Poruka</label>
      <textarea
        type="text"
        id="porukaInput"
        readOnly={true}
        value={ponuda.poruka}
      />

      <label>Odgovor</label>
      <textarea
        type="text"
        id="odogovorInput"
        readOnly={true}
        value={ponuda.odgovor}
      />

      <p>Cijena: {new Intl.NumberFormat().format(ponuda.cijena)} KM</p>

      <Button
        value="PRIHVATI"
        id="primary"
        marginTop="2rem"
        marginRight="2rem"
        onClick={() => finishOffer(true)}
      ></Button>
      <Button
        value="ODBIJ"
        type="danger"
        marginLeft="2rem"
        onClick={() => finishOffer("false")}
      />
    </div>
  );
}

export default PrihvatanjePonudeFizickogLica;
